import React from "react";
import AddDeptoForm from "./AddDeptoForm";

const AddDepto = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="col-12">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nuevo Departamento"}
        </button>
      </div>
      {show && (
        <div className="col-md-8 offset-md-2 mb-3">
          <AddDeptoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddDepto;
